import { Link } from "react-router-dom";
import { Container } from "../components/site/Motion";

export default function NotFound() {
  return (
    <Container className="py-32 text-center" >
      <h1 className="text-5xl" data-testid="not-found-title">Page introuvable</h1>
      <p className="mt-4 text-[#242020]/70">La page demandée n'existe pas ou a été déplacée.</p>
      <Link to="/" className="btn-primary mt-8" data-testid="not-found-home">Retour à l'accueil</Link>
    </Container>
  );
}
